import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { DisabilityData, MyCpgPodsSettings, MyCpgPodsTypes, PodContent } from '../mycpg-pod-models';
import { PodGridContent } from './pod-grid-content';
import { PodGridContentItem } from './pod-grid-content-item';
import { PodGridItem } from './pod-grid-item';
import { PodGridItemHeader } from './pod-grid-item-header';


interface Props {
	settings: MyCpgPodsSettings;
}
export function DisabilityPlanPod(props: Props) {

	const { settings } = props;
	const disabilityPlan = useSelector<TcsmStates, DisabilityData>(state => state?.mycpgPodsState?.pods?.disability_data);
	const routeMatch = useRouteMatch();
	const hasPlan = disabilityPlan?.disability_ltd_content === PodContent.CONTENT || disabilityPlan?.disability_std_content === PodContent.CONTENT;

	if (disabilityPlan?.disability_pod === YesNoIndicators.No) {
		return null;
	}

	const renderContent = () => {

		if (disabilityPlan?.disability_std_content === PodContent.CONTENT && disabilityPlan?.disability_ltd_content === PodContent.CONTENT) {
			return (
				<PodGridContentItem>
					<div dangerouslySetInnerHTML={{ __html: settings?.bothLongAndShortText }} />
				</PodGridContentItem>);
		}

		if (disabilityPlan?.disability_std_content === PodContent.CONTENT) {
			return (
				<PodGridContentItem>
					<div dangerouslySetInnerHTML={{ __html: settings?.shortOnlyText }} />
				</PodGridContentItem>);
		}

		if (disabilityPlan?.disability_ltd_content === PodContent.CONTENT) {
			return (
				<PodGridContentItem>
					<div dangerouslySetInnerHTML={{ __html: settings?.longOnlyText }} />
				</PodGridContentItem>);
		}

		return (
			<PodGridContentItem>
				<div dangerouslySetInnerHTML={{ __html: settings?.noDisText }} />
			</PodGridContentItem>
		);
	};

	return (
		<PodGridItem>
			<PodGridItemHeader title={settings?.disabilityPlanTitle}>
				<Link to={`${routeMatch?.path}?type=${MyCpgPodsTypes.DISABLE}`}>{!hasPlan ? settings?.learnMoreText : settings?.seeMoreLinkText}</Link>
			</PodGridItemHeader>
			<PodGridContent>
				{renderContent()}
			</PodGridContent>
		</PodGridItem>
	);

}

